import { render } from "./ListeSecteurPage.vue?vue&type=template&id=c53c4f66&ts=true"
import script from "./ListeSecteurPage.vue?vue&type=script&lang=ts"
export * from "./ListeSecteurPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__